import { FitnessProfile } from "@/clients/models/FitnessProfile";
import { FitnessProfileService } from "@/clients/services/FitnessProfileService";
import { QueryKeys } from "@/constants/query-keys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

/**
 * PUT merges server-side, so each onboarding screen sends only its own field
 * and the others are preserved.
 */
export const useUpdateFitnessProfile = () => {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending } = useMutation({
    mutationKey: [QueryKeys.FITNESS_PROFILE],
    mutationFn: async (fitnessProfile: FitnessProfile) => {
      const { data } =
        await FitnessProfileService.updateFitnessProfileApiV1FitnessProfilePut(fitnessProfile);

      return data;
    },
    onSuccess: (data) => {
      // The response carries the merged object, so seed the cache with it rather
      // than refetching — back-navigation then prefills without a round trip.
      queryClient.setQueryData([QueryKeys.FITNESS_PROFILE], data);
    },
  });

  return {
    updateFitnessProfile: mutate,
    updateFitnessProfileAsync: mutateAsync,
    isUpdating: isPending,
  };
};
